import { render } from "./DiscoverArtistDetail.vue?vue&type=template&id=4b998464&scoped=true"
import script from "./DiscoverArtistDetail.vue?vue&type=script&lang=js"
export * from "./DiscoverArtistDetail.vue?vue&type=script&lang=js"

import "./DiscoverArtistDetail.vue?vue&type=style&index=0&id=4b998464&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b998464"]])

export default __exports__